export default class CustomAccordions {
  constructor() {
    this.accordions = $('.inner-accordion');
    this.accordions.attr('aria-expanded', 'true');
    this.collapsedByDefault = $('.inner-accordion:not(.open)');

    this.collapseDefault();
  }

  listenEvents() {
    this.accordions.find('> p').on('click', function() {
      const header = $(this);

      if (header.parent().attr('aria-expanded') === 'true') {
        header.parent().attr('aria-expanded', 'false');
        header.next().slideUp(0);
      } else {
        header.next().slideDown(0);
        header.parent().attr('aria-expanded', 'true');
      }
    });
  }

  stopListening() {
    this.accordions.off('click');
  }

  expandAll() {
    this.accordions.attr('aria-expanded', 'true');
    this.accordions.find('> div').slideDown(0);
  }

  collapseAll() {
    this.accordions.attr('aria-expanded', 'false');
    this.accordions.find('> div').slideUp(0);
  }

  collapseDefault() {
    this.collapsedByDefault.attr('aria-expanded', 'false');
    this.collapsedByDefault.find('> div').slideUp(0);
  }
}
